import { MilesJPool } from "./MilesJPool";
import { NotionPost } from "./NotionPost";
import { WhatTheHex } from "./WhatTheHex";
import { OhYou } from "./OhYou";
import { HireAnApprentice } from "./HireAnApprentice";
import { MasonryDemo } from "./MasonryDemo";
import { SlopBox } from "./SlopBox";
// import { CurriculumVitae } from "./CurriculumVitae";
import { ReactComponent as GrafanaIcon } from "icons/grafana.svg";

export const CarouselItemSet = [
  <MilesJPool />,
  <NotionPost
    emoji="🎛️"
    title="Elevating my desk"
    headerImage="https://images.unsplash.com/photo-1487017159836-4e23ece2e4cf"
    href="https://milesjpool.notion.site/Elevating-my-desk-127ea37a280e808ab350ec64626f20ca"
    githubRepo={{ url: "https://github.com/Milesjpool/standing-desk" }}
    extraIconLinks={[
      {
        href: "https://grafana.aesop.casa/public-dashboards/4751c3c137974d77a0905190a4f2ccc0",
        Icon: GrafanaIcon,
      },
    ]}
  />,
  <WhatTheHex />,
  <NotionPost
    emoji="🧊"
    title="Colour distance calculation [pt. I]"
    headerImage="https://images.unsplash.com/photo-1502691876148-a84978e59af8"
    href="https://milesjpool.notion.site/Colour-distance-calculation-pt-I-4f116bfa10e2415d93c5e50ba10e3591"
  />,
  // <CurriculumVitae />,
  <SlopBox />,
  <OhYou />,
  <NotionPost
    emoji="📆"
    title="How we talk about project dates."
    headerImage="https://images.unsplash.com/photo-1633265486501-0cf524a07213"
    href="https://milesjpool.notion.site/How-we-talk-about-project-dates-246ea37a280e80b1a925e96d8c852525"
  />,
  <HireAnApprentice />,
  <MasonryDemo />,
]


